// @core/api/endpoints/payment/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AttachPaymentMethodToLegalEntity } from './attach_payment_method_to_legal_entity';
import { AuthorizePayment } from './authorize_payment';
import { BatchGetEntityPayments } from './batch_get_entity_payments';
import { CapturePayment } from './capture_payment';
import { ChargeEntity } from './charge_entity';
import { ChargePayment } from './charge_payment';
import { CreatePaymentMethod } from './create_payment_method';
import { CreatePaymentPolicy } from './create_payment_policy';
import { CreatePaymentProvider } from './create_payment_provider';
import { CreatePaymentRoute } from './create_payment_route';
import { DeletePaymentMethod } from './delete_payment_method';
import { DeletePaymentPolicy } from './delete_payment_policy';
import { DeletePaymentProvider } from './delete_payment_provider';
import { DeletePaymentRoute } from './delete_payment_route';
import { DeletePaymentType } from './delete_payment_type';
import { DetachPaymentMethodFromLegalEntity } from './detach_payment_method_from_legal_entity';
import { GetContractRequisitesForLegalEntity } from './get_contract_requisites_for_legal_entity';
import { GetEntityPayment } from './get_entity_payment';
import { GetPayment } from './get_payment';
import { GetPaymentMethod } from './get_payment_method';
import { GetPaymentPolicy } from './get_payment_policy';
import { GetPaymentProvider } from './get_payment_provider';
import { GetPaymentRoute } from './get_payment_route';
import { GetPaymentType } from './get_payment_type';
import { HandleProviderWebhook } from './handle_provider_webhook';
import { ListPaymentMethods } from './list_payment_methods';
import { ListPaymentMethodsByLegalEntity } from './list_payment_methods_by_legal_entity';
import { ListPaymentPolicies } from './list_payment_policies';
import { ListPaymentProviders } from './list_payment_providers';
import { ListPaymentRoutes } from './list_payment_routes';
import { ListPaymentTypes } from './list_payment_types';
import { ListPayments } from './list_payments';
import { ListProviderEvents } from './list_provider_events';
import { RefundEntity } from './refund_entity';
import { RefundPayment } from './refund_payment';
import { RegisterPaymentType } from './register_payment_type';
import { ResolvePaymentContext } from './resolve_payment_context';
import { RetryProviderEvent } from './retry_provider_event';
import { SetDefaultPaymentMethod } from './set_default_payment_method';
import { TestPaymentProvider } from './test_payment_provider';
import { UpdateBankRequisites } from './update_bank_requisites';
import { UpdatePaymentPolicy } from './update_payment_policy';
import { UpdatePaymentProvider } from './update_payment_provider';
import { UpdatePaymentRoute } from './update_payment_route';
import { UpdatePaymentType } from './update_payment_type';
import { VoidPayment } from './void_payment';

// Re-export individual endpoints
export {
  AttachPaymentMethodToLegalEntity,
  AuthorizePayment,
  BatchGetEntityPayments,
  CapturePayment,
  ChargeEntity,
  ChargePayment,
  CreatePaymentMethod,
  CreatePaymentPolicy,
  CreatePaymentProvider,
  CreatePaymentRoute,
  DeletePaymentMethod,
  DeletePaymentPolicy,
  DeletePaymentProvider,
  DeletePaymentRoute,
  DeletePaymentType,
  DetachPaymentMethodFromLegalEntity,
  GetContractRequisitesForLegalEntity,
  GetEntityPayment,
  GetPayment,
  GetPaymentMethod,
  GetPaymentPolicy,
  GetPaymentProvider,
  GetPaymentRoute,
  GetPaymentType,
  HandleProviderWebhook,
  ListPaymentMethods,
  ListPaymentMethodsByLegalEntity,
  ListPaymentPolicies,
  ListPaymentProviders,
  ListPaymentRoutes,
  ListPaymentTypes,
  ListPayments,
  ListProviderEvents,
  RefundEntity,
  RefundPayment,
  RegisterPaymentType,
  ResolvePaymentContext,
  RetryProviderEvent,
  SetDefaultPaymentMethod,
  TestPaymentProvider,
  UpdateBankRequisites,
  UpdatePaymentPolicy,
  UpdatePaymentProvider,
  UpdatePaymentRoute,
  UpdatePaymentType,
  VoidPayment,
};

// Namespace export for convenient usage
export const paymentApi = {
  AttachPaymentMethodToLegalEntity,
  AuthorizePayment,
  BatchGetEntityPayments,
  CapturePayment,
  ChargeEntity,
  ChargePayment,
  CreatePaymentMethod,
  CreatePaymentPolicy,
  CreatePaymentProvider,
  CreatePaymentRoute,
  DeletePaymentMethod,
  DeletePaymentPolicy,
  DeletePaymentProvider,
  DeletePaymentRoute,
  DeletePaymentType,
  DetachPaymentMethodFromLegalEntity,
  GetContractRequisitesForLegalEntity,
  GetEntityPayment,
  GetPayment,
  GetPaymentMethod,
  GetPaymentPolicy,
  GetPaymentProvider,
  GetPaymentRoute,
  GetPaymentType,
  HandleProviderWebhook,
  ListPaymentMethods,
  ListPaymentMethodsByLegalEntity,
  ListPaymentPolicies,
  ListPaymentProviders,
  ListPaymentRoutes,
  ListPaymentTypes,
  ListPayments,
  ListProviderEvents,
  RefundEntity,
  RefundPayment,
  RegisterPaymentType,
  ResolvePaymentContext,
  RetryProviderEvent,
  SetDefaultPaymentMethod,
  TestPaymentProvider,
  UpdateBankRequisites,
  UpdatePaymentPolicy,
  UpdatePaymentProvider,
  UpdatePaymentRoute,
  UpdatePaymentType,
  VoidPayment,
};
